import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  SmartSmsStatisticsByRequestIdRecipientIdItem,
} from 'src/app/core/api/models';
import { SmartSmsRequestRecipientScheduledMessagesDetail } from 'src/app/core/api/models/smart-sms-request-recipient-scheduled-messages-detail';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SendSmartDetailsByDeliveryService } from 'src/app/core/services/sendSmartDetailsByDelivery.service';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { TranslationService } from './../../../../i18n/translation.service';

@Component({
    selector: 'app-send-smart-sms-details-by-delivery',
    templateUrl: './send-smart-sms-details-by-delivery.component.html',
    styleUrls: ['./send-smart-sms-details-by-delivery.component.scss'],
    standalone: false
})
export class SendSmartDetailsByDeliveryComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  @Output('closeDetails') output_closeTextParserInboxesPage =
    new EventEmitter<boolean>();

  fields = 'pages.sendSmartSms.form.fields.';

  items: Array<SmartSmsStatisticsByRequestIdRecipientIdItem>;
  scheduledMessageDetailsItems: SmartSmsRequestRecipientScheduledMessagesDetail[] =
    [];

  StatisticsSendStatusEnumValues: GetEnumValuesDto[] = [];

  protected onDestroy$ = new Subject<void>();
  totalPartsCount: number;
  totalSmsCount: number;

  constructor(public translationService: TranslationService) {
    super();
    this.items = SendSmartDetailsByDeliveryService.items;
    this.scheduledMessageDetailsItems =
      SendSmartDetailsByDeliveryService.scheduledMessageDetails;
  }

  ngOnInit() {
    try {
      this.getEnumsValues();
      this.pageConfig.showBackBtn = false;
      this.totalPartsCount = this.items
        .map((item) => item.partsCount)
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);

      this.totalSmsCount = this.items
        .map((item) => item.smsCount)
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);
    } catch (error) {
      this.loggerService.logError(
        'app-send-smart-sms-details',
        error,
        EventTypes.smartSms
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('StatisticsSendStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.StatisticsSendStatusEnumValues = values));
  }

  configTableColumns(): void {
    throw new Error('Method not implemented.');
  }
  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  onPrint() {
    window.print();
  }
  onBack() {
    this.output_closeTextParserInboxesPage.emit(true);
  }
}

